// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608140830/js/" + chunkId + "." + {"44":"bda05777","225":"6fb9dba5","481":"132edcfd","486":"d44e8b84","770":"eb92050d"}[chunkId] + ".0.9825549760292344.chunk.js";
};